import { memo, ReactNode } from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { StyledRootScrollbar, StyledScrollbar } from "./styles";

type ScrollbarProps = {
  children: ReactNode;
  sx: SxProps<Theme>;
};

function Scrollbar({ children, sx }: ScrollbarProps) {
  const userAgent =
    typeof navigator === "undefined" ? "SSR" : navigator.userAgent;

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );

  if (isMobile) {
    return <Box sx={{ overflowX: "auto", ...sx }}>{children}</Box>;
  }

  return (
    <StyledRootScrollbar>
      <StyledScrollbar timeout={500} clickOnTrack={false} sx={sx}>
        {children}
      </StyledScrollbar>
    </StyledRootScrollbar>
  );
}

export default memo(Scrollbar);
